import {bp} from './namespace.js';
import './effects.js';

$.extend(true, bp, {
  favorites: (function () {
    var MAX_COMPARE_SLOTS = 4;
    var MAX_COMPARE_SHARE_IDS = 4;
    var GUEST_FAVORITE_LIMIT = 4;
    var LOGIN_PATH = '/inloggen/';
    var EMPTY_VALUE_PLACEHOLDERS = ['—', '–', '-'];
    var DEFAULT_INQUIRY_MESSAGE = 'Graag ontvang ik additionele informatie over dit pand. U kunt mij bereiken via bijgevoegde contactgegevens.';
    var MAX_FACILITY_PILLS = 2;
    var PRICE_UNIT_STORAGE_KEY = 'bp.compare.price-unit';
    var DEFAULT_PRICE_UNIT = 'm2_year';
    // Keys match the `price_variants` payload built by the compare serializer.
    var priceUnitOptions = [
      {'key': 'm2_year', 'label': 'm²/jaar'},
      {'key': 'm2_month', 'label': 'm²/maand'},
      {'key': 'month', 'label': 'Per maand'},
      {'key': 'year', 'label': 'Per jaar'},
    ];
    var rowDefinitions = [
      {'id': 'type', 'label': 'Type object', 'category': 'kerngegevens'},
      {'id': 'floor_area', 'label': 'Oppervlakte', 'category': 'kerngegevens'},
      {'id': 'price', 'label': 'Prijs', 'category': 'kerngegevens'},
      {'id': 'building_year', 'label': 'Bouwjaar', 'category': 'kerngegevens'},
      {'id': 'parking_spaces', 'label': 'Parkeerplaatsen', 'category': 'kerngegevens'},
      {'id': 'city', 'label': 'Plaats', 'category': 'kerngegevens'},
      {'id': 'neighborhood', 'label': 'Wijk / buurt', 'category': 'kerngegevens'},
      {'id': 'energy_label', 'label': 'Energielabel', 'category': 'duurzaamheid'},
      {'id': 'facilities', 'label': 'Voorzieningen', 'category': 'duurzaamheid'},
      {'id': 'description', 'label': 'Omschrijving', 'category': 'omschrijving'},
      {'id': 'secondary_use', 'label': 'Secundair gebruik', 'category': 'omschrijving'},
      {'id': 'maintenance_inside', 'label': 'Onderhoud binnen', 'category': 'omschrijving'},
      {'id': 'maintenance_outside', 'label': 'Onderhoud buiten', 'category': 'omschrijving'},
      {'id': 'transport_ov', 'label': 'Tram, bus, metro', 'category': 'bereikbaarheid'},
      {'id': 'transport_train', 'label': 'Trein', 'category': 'bereikbaarheid'},
      {'id': 'transport_airport', 'label': 'Vliegveld, haven', 'category': 'bereikbaarheid'},
    ];
    var categoryLabels = {
      'kerngegevens': 'Kerngegevens',
      'duurzaamheid': 'Duurzaamheid',
      'omschrijving': 'Omschrijving',
      'bereikbaarheid': 'Bereikbaarheid',
    };
    var defaultRowOrder = {
      'kerngegevens': ['type', 'floor_area', 'price', 'building_year', 'parking_spaces', 'city', 'neighborhood'],
      'duurzaamheid': ['energy_label', 'facilities'],
      'omschrijving': ['description', 'secondary_use', 'maintenance_inside', 'maintenance_outside'],
      'bereikbaarheid': ['transport_ov', 'transport_train', 'transport_airport'],
    };
    var expandableRowLabels = {
      'description': {
        closed: 'Toon tekst',
        open: 'Verberg tekst',
      },
    };
    var EXPANDABLE_TEXT_PREVIEW_LENGTH = 180;
    // Bumped when the comparer session is reset so a pending scroll restore
    // cannot move a freshly opened modal.
    var compareScrollGeneration = 0;
    var compareScrollRestore = null;
    var compareScrollRestoreFrame = 0;
    var compareState = {
      compareListingsById: {},
      slotIds: ['', '', '', ''],
      inquirySelections: [false, false, false, false],
      rowOrder: cloneRowOrder(),
      collapsedCategories: {},
      expandedDescriptions: {},
      diffOnly: false,
      pointerDrag: null,
      inquiryPrefill: null,
      inquirySubmitIds: null,
      priceUnit: DEFAULT_PRICE_UNIT,
      initialized: false,
      comparePageBootstrapped: false,
    };
    var showFavoritesOnMap = false;
    var favoritePks = [];
    var userIsAuthenticated = false;

    var _sync_favorite_map_markers = function () {
      if (bp.maps !== undefined && typeof bp.maps.sync_favorite_map_markers === 'function') {
        bp.maps.sync_favorite_map_markers(showFavoritesOnMap, favoritePks);
      }
    };

    var _store_favorite_state = function (result) {
      favoritePks = result.favorite_pks || favoritePks;
      showFavoritesOnMap = result.show_favorites_on_map === true;
      _sync_favorite_map_markers();
    };

    function cloneRowOrder() {
      var cloned = {};
      Object.keys(defaultRowOrder).forEach(function (category) {
        cloned[category] = defaultRowOrder[category].slice();
      });
      return cloned;
    }

    function isKnownPriceUnit(value) {
      return priceUnitOptions.some(function (option) {
        return option.key === value;
      });
    }

    // sessionStorage keeps the price unit for the browsing session without
    // adding a session write to every compare request. It throws in Safari
    // private mode, so every access is guarded.
    function readStoredPriceUnit() {
      try {
        var stored = window.sessionStorage.getItem(PRICE_UNIT_STORAGE_KEY);
        return isKnownPriceUnit(stored) ? stored : DEFAULT_PRICE_UNIT;
      } catch (error) {
        return DEFAULT_PRICE_UNIT;
      }
    }

    function storePriceUnit(unit) {
      try {
        window.sessionStorage.setItem(PRICE_UNIT_STORAGE_KEY, unit);
      } catch (error) {
        // Storage unavailable: the selection still applies for this render.
      }
    }

    function resetCompareSessionState() {
      compareScrollGeneration += 1;
      compareScrollRestore = null;
      if (compareScrollRestoreFrame) {
        window.cancelAnimationFrame(compareScrollRestoreFrame);
        compareScrollRestoreFrame = 0;
      }
      compareState.slotIds = ['', '', '', ''];
      compareState.inquirySelections = [false, false, false, false];
      compareState.rowOrder = cloneRowOrder();
      compareState.collapsedCategories = {};
      compareState.expandedDescriptions = {};
      compareState.diffOnly = false;
      compareState.inquirySubmitIds = null;
      compareState.priceUnit = readStoredPriceUnit();
      stopPointerDrag();
      showCompareStep();
      setCompareTitle('Panden vergelijken', 'Kies tot 4 panden uit je favorieten');
      $('#favorites-compare-diff-only').prop('checked', false);
      $('#favorites-compare-inquiry-status').text('');
      $('#favorites-compare-inquiry-form')[0].reset();
      $('#compare-inquiry-message').val(DEFAULT_INQUIRY_MESSAGE);
    }

    function toInt(value) {
      var parsed = parseInt(value, 10);
      return isNaN(parsed) ? null : parsed;
    }

    function getLoginRedirectUrl() {
      var nextPath = (window.location.pathname || '/') + (window.location.search || '');
      return LOGIN_PATH + '?next=' + encodeURIComponent(nextPath);
    }

    function canonicalizeIds(ids, maxCount) {
      var parsedIds = [];
      if (!Array.isArray(ids)) {
        return [];
      }

      ids.forEach(function (value) {
        var intValue = toInt(value);
        if (intValue && intValue > 0) {
          parsedIds.push(intValue);
        }
      });

      var unique = parsedIds.filter(function (value, index, arr) {
        return arr.indexOf(value) === index;
      }).sort(function (a, b) {
        return a - b;
      });

      if (typeof maxCount === 'number') {
        return unique.slice(0, maxCount);
      }
      return unique;
    }

    function escapeHtml(value) {
      var text = String(value || '');
      return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function parseUrlIds(idsValue) {
      if (!idsValue) {
        return [];
      }
      if (Array.isArray(idsValue)) {
        return canonicalizeIds(idsValue, MAX_COMPARE_SLOTS);
      }
      if (typeof idsValue === 'string') {
        return canonicalizeIds(idsValue.split(','), MAX_COMPARE_SLOTS);
      }
      return [];
    }

    function getListingById(id) {
      return compareState.compareListingsById[id] || null;
    }

    function getSelectedSlotIds() {
      return compareState.slotIds.filter(function (id) {
        return !!toInt(id);
      });
    }

    function getCanonicalSelectedIdsForSharing() {
      return canonicalizeIds(getSelectedSlotIds(), MAX_COMPARE_SHARE_IDS);
    }

    function buildShareUrl() {
      var canonicalIds = getCanonicalSelectedIdsForSharing();
      var baseUrl = window.location.origin + '/pandvergelijker/';
      if (!canonicalIds.length) {
        return baseUrl;
      }
      return baseUrl + '?ids=' + canonicalIds.join(',');
    }

    function getShareStreetNames() {
      var names = [];
      getCanonicalSelectedIdsForSharing().forEach(function (id) {
        var listing = getListingById(id);
        if (!listing) {
          return;
        }
        if (listing.street_name) {
          names.push(listing.street_name);
        }
      });
      return names.slice(0, MAX_COMPARE_SHARE_IDS);
    }

    function getCsrfToken() {
      var cookie = document.cookie || '';
      var parts = cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var item = parts[i].trim();
        if (item.indexOf('csrftoken=') === 0) {
          return decodeURIComponent(item.substring('csrftoken='.length));
        }
      }
      return '';
    }

    function upsertCompareListings(listings) {
      if (!Array.isArray(listings)) {
        return;
      }
      listings.forEach(function (listing) {
        if (!listing || !listing.id) {
          return;
        }
        compareState.compareListingsById[listing.id] = listing;
      });
    }

    function applyInquiryPrefill(prefill) {
      if (!prefill || typeof prefill !== 'object') {
        return;
      }
      compareState.inquiryPrefill = prefill;
    }

    function fillInquiryFormFromPrefill() {
      var prefill = compareState.inquiryPrefill;
      if (!prefill) {
        return;
      }

      $('#compare-inquiry-name').val(prefill.name || '');
      $('#compare-inquiry-surname').val(prefill.surname || '');
      $('#compare-inquiry-email').val(prefill.email || '');
      $('#compare-inquiry-phone').val(prefill.phone || '');
      $('#compare-inquiry-company').val(prefill.company_name || '');
      $('#compare-inquiry-message').val(prefill.message || DEFAULT_INQUIRY_MESSAGE);
    }

    function getFavoriteCompareIds() {
      return favoritePks.map(toInt).filter(function (id) {
        return !!getListingById(id);
      });
    }

    function isCompareUiVisible() {
      return $('#favorites-compare-modal').hasClass('in');
    }

    function refreshOpenCompare() {
      ensureCompareDataForIds(favoritePks, function () {
        renderCompare();
        bindCompareEvents();
      });
    }

    function ensureCompareDataForIds(ids, callback) {
      var missingIds = canonicalizeIds(ids, null).filter(function (id) {
        return !compareState.compareListingsById[id];
      });
      // Compare data is no longer preloaded with /data/favorites/ (it made
      // every page load pay for the modal); with no explicit ids and nothing
      // cached yet, fetch the session favorites from the endpoint instead.
      var needsInitialLoad =
        !missingIds.length &&
        !Object.keys(compareState.compareListingsById).length;

      if (!missingIds.length && !needsInitialLoad) {
        if (typeof callback === 'function') {
          callback();
        }
        return;
      }

      // The session endpoint returns every favorite in one request. Explicit
      // ids are only needed for shared listings outside the saved favorites.
      var savedIds = canonicalizeIds(favoritePks, null);
      var needsFavorites = needsInitialLoad || missingIds.some(function (id) {
        return savedIds.indexOf(id) !== -1;
      });
      var explicitIds = missingIds.filter(function (id) {
        return !needsFavorites || savedIds.indexOf(id) === -1;
      });
      var batches = [];
      for (var index = 0; index < explicitIds.length; index += MAX_COMPARE_SLOTS) {
        batches.push(explicitIds.slice(index, index + MAX_COMPARE_SLOTS));
      }
      if (needsFavorites) {
        batches.push([]);
      }

      var pending = batches.length;
      var loadFailed = false;
      batches.forEach(function (batch) {
        var listingsUrl = '/data/pandvergelijker/listings/';
        if (batch.length) {
          listingsUrl += '?ids=' + encodeURIComponent(batch.join(','));
        }

        $.ajax({
          dataType: 'json',
          url: listingsUrl,
          cache: false,
          async: true,
          success: function (result) {
            upsertCompareListings(result.listings || []);
            applyInquiryPrefill(result.inquiry_prefill);
          },
          error: function () {
            loadFailed = true;
          },
          complete: function () {
            pending -= 1;
            if (pending) {
              return;
            }
            if (loadFailed) {
              $('#favorites-compare-picker-status').text(
                'Favorieten konden niet worden geladen. Sluit de vergelijking en probeer opnieuw.'
              );
              $('#favorites-compare-modal').modal('show');
            } else if (typeof callback === 'function') {
              callback();
            }
          },
        });
      });
    }

    function setSlotsFromIds(ids) {
      var canonicalIds = canonicalizeIds(ids, MAX_COMPARE_SLOTS);
      var nextSlots = ['', '', '', ''];
      var nextInquirySelections = [false, false, false, false];

      canonicalIds.forEach(function (id, index) {
        if (index >= MAX_COMPARE_SLOTS) {
          return;
        }
        nextSlots[index] = id;
        nextInquirySelections[index] = true;
      });

      compareState.slotIds = nextSlots;
      compareState.inquirySelections = nextInquirySelections;
    }

    function getDefaultSlotIds() {
      return getFavoriteCompareIds().slice(0, MAX_COMPARE_SLOTS);
    }

    function setCompareTitle(title, subtitle) {
      $('#favorites-compare-title').text(title);
      $('#favorites-compare-subtitle').text(subtitle);
    }

    function showCompareStep() {
      $('#favorites-compare-step-1').addClass('is-active');
      $('#favorites-compare-step-2').removeClass('is-active');
    }

    function showInquiryStep() {
      $('#favorites-compare-step-1').removeClass('is-active');
      $('#favorites-compare-step-2').addClass('is-active');
    }

    function getFacilityNames(listing) {
      return Array.isArray(listing.facilities) ? listing.facilities : [];
    }

    function getPriceLines(listing) {
      var lines = [];
      var variants = listing.price_variants || {};
      var hasRentVariants = Object.keys(variants).length > 0;

      if (hasRentVariants) {
        // The per-object units are omitted when a listing has no floor area to
        // multiply by, so the selected unit can legitimately be missing.
        lines.push(variants[compareState.priceUnit] || '—');
      }
      if (listing.price_purchase) {
        lines.push(listing.price_purchase);
      }
      if (listing.price_purchase_m2) {
        lines.push(listing.price_purchase_m2);
      }
      if (!lines.length && listing.price) {
        lines.push(listing.price);
      }
      return lines;
    }

    function getComparableValue(rowId, listing) {
      if (!listing) {
        return '';
      }
      if (rowId === 'price') {
        return getPriceLines(listing).join(' ');
      }
      if (rowId === 'facilities') {
        return getFacilityNames(listing).slice().sort().join(', ');
      }
      return listing[rowId] || '';
    }

    function normalizeComparableValue(value) {
      var normalized = String(value || '').trim().toLowerCase();
      return EMPTY_VALUE_PLACEHOLDERS.indexOf(normalized) === -1 ? normalized : '';
    }

    function isIdenticalRow(rowId) {
      var listings = compareState.slotIds.map(getListingById).filter(Boolean);
      var filledValues = listings.map(function (listing) {
        return normalizeComparableValue(getComparableValue(rowId, listing));
      }).filter(Boolean);

      if (!listings.length || filledValues.length === 1) {
        return false;
      }
      return filledValues.every(function (value) {
        return value === filledValues[0];
      });
    }

    function getDiffHiddenRowIds() {
      var hidden = {};
      if (!compareState.diffOnly) {
        return hidden;
      }
      rowDefinitions.forEach(function (rowDefinition) {
        if (isIdenticalRow(rowDefinition.id)) {
          hidden[rowDefinition.id] = true;
        }
      });
      return hidden;
    }

    function isCategoryHiddenByDiff(category, diffHiddenRowIds) {
      return compareState.rowOrder[category].every(function (rowId) {
        return !!diffHiddenRowIds[rowId];
      });
    }

    function getListingTitle(listing) {
      return listing.street_name || listing.address || ('Pand ' + listing.id);
    }

    function getListingLinkLabel(listing) {
      var title = getListingTitle(listing);
      return listing.city ? (title + ', ' + listing.city) : title;
    }

    // A native <option> is single-line, so the "{type} · {city}" detail from the
    // design is appended after an en dash instead of on a second line.
    function getListingOptionLabel(listing) {
      var details = [listing.type, listing.city].filter(Boolean).join(' · ');
      var title = getListingTitle(listing);
      return details ? (title + ' – ' + details) : title;
    }

    function makeSlotOptions(selectedId) {
      var options = [];
      var selectedInt = toInt(selectedId);
      var favoriteIds = getFavoriteCompareIds();
      var selectedIds = getSelectedSlotIds().map(toInt);
      options.push('<option value="">' + (selectedId ? '— Leeg —' : '+ Voeg pand toe') + '</option>');

      if (selectedInt && favoriteIds.indexOf(selectedInt) === -1) {
        var selectedListing = getListingById(selectedInt);
        if (selectedListing) {
          options.push(
            '<option value="' + selectedListing.id + '" selected>' +
            escapeHtml(getListingOptionLabel(selectedListing) + ' (niet in favorieten)') +
            '</option>'
          );
        }
      }

      var selectedOptions = [];
      var availableOptions = [];
      favoriteIds.forEach(function (listingId) {
        var listing = getListingById(listingId);
        if (!listing) {
          return;
        }
        var isCurrent = selectedInt === listingId;
        var isSelectedElsewhere = !isCurrent && selectedIds.indexOf(listingId) !== -1;
        var option = '<option value="' + listing.id + '"' +
          (isCurrent ? ' selected' : '') +
          (isSelectedElsewhere ? ' disabled' : '') + '>' +
          escapeHtml(getListingOptionLabel(listing)) +
          '</option>';
        (isCurrent || isSelectedElsewhere ? selectedOptions : availableOptions).push(option);
      });
      if (selectedOptions.length) {
        options.push('<optgroup label="In vergelijking">' + selectedOptions.join('') + '</optgroup>');
      }
      if (availableOptions.length) {
        options.push('<optgroup label="Niet geselecteerd — kies om te vervangen">' + availableOptions.join('') + '</optgroup>');
      }
      return options.join('');
    }

    function renderSlotPhoto(listing) {
      var inner = listing && listing.photo
        ? '<img src="' + escapeHtml(listing.photo) + '" alt="' + escapeHtml(getListingLinkLabel(listing)) + '" loading="lazy">'
        : '<span class="favorites-slot-photo-fallback" aria-hidden="true"><i class="far fa-image"></i></span>';

      if (!listing || !listing.url) {
        return '<span class="favorites-slot-photo">' + inner + '</span>';
      }
      // The title link below points at the same page, so the photo is kept out
      // of the tab order to avoid a duplicate stop for keyboard users.
      return '<a class="favorites-slot-photo" href="' + escapeHtml(listing.url) + '" target="_blank" rel="noopener noreferrer" tabindex="-1" aria-hidden="true">' + inner + '</a>';
    }

    function renderSlotTitle(listing) {
      var label = getListingLinkLabel(listing);
      if (!listing.url) {
        return '<span class="favorites-slot-title">' + escapeHtml(label) + '</span>';
      }
      return '<a class="favorites-slot-title" href="' + escapeHtml(listing.url) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(label) + '</a>';
    }

    function renderSlotHeader(slotIndex) {
      var slotId = compareState.slotIds[slotIndex];
      var listing = getListingById(slotId);
      var isFilled = !!listing;
      var inquiryChecked = !!compareState.inquirySelections[slotIndex];
      var inquiryCheckboxHtml = '';
      var identityHtml;

      if (isFilled) {
        identityHtml =
          renderSlotPhoto(listing) +
          renderSlotTitle(listing) +
          (listing.type ? '<div class="favorites-slot-type">' + escapeHtml(listing.type) + '</div>' : '');
        inquiryCheckboxHtml =
          '<label class="favorites-slot-inquiry">' +
          '<input type="checkbox" class="favorites-slot-inquiry-checkbox" data-slot-index="' + slotIndex + '"' + (inquiryChecked ? ' checked' : '') + '> ' +
          'Meenemen in aanvraag' +
          '</label>';
      } else {
        identityHtml =
          renderSlotPhoto(null) +
          '<span class="favorites-slot-title favorites-slot-placeholder">Geen pand</span>';
      }

      return '' +
        '<th class="compare-col-header' + (isFilled ? '' : ' favorites-compare-col-empty') + '">' +
        identityHtml +
        '<div class="favorites-slot-header-controls">' +
        '<select class="form-control input-sm favorites-slot-select" data-slot-index="' + slotIndex + '" aria-label="Pand kolom ' + (slotIndex + 1) + '">' +
        makeSlotOptions(slotId) +
        '</select>' +
        '<button type="button" class="favorites-slot-remove" data-slot-index="' + slotIndex + '" title="Verwijder uit vergelijking" aria-label="Verwijder uit vergelijking"' + (isFilled ? '' : ' disabled') + '>' +
        '<i class="fas fa-trash-alt"></i>' +
        '</button>' +
        '</div>' +
        inquiryCheckboxHtml +
        '</th>';
    }

    function renderCategoryRow(category, hiddenByDiff) {
      var isCollapsed = !!compareState.collapsedCategories[category];
      var iconClass = isCollapsed ? 'fa-chevron-right' : 'fa-chevron-down';
      var hiddenClass = hiddenByDiff ? ' hidden' : '';
      return '' +
        '<tr class="favorites-compare-category-row' + hiddenClass + '" data-category="' + category + '">' +
        '<td colspan="5">' +
        '<button type="button" class="btn btn-link btn-xs favorites-category-toggle" data-category="' + category + '">' +
        '<i class="fas ' + iconClass + '"></i> ' + escapeHtml(categoryLabels[category] || category) +
        '</button>' +
        '</td>' +
        '</tr>';
    }

    function previewExpandableText(text) {
      if (text.length > EXPANDABLE_TEXT_PREVIEW_LENGTH) {
        return text.slice(0, EXPANDABLE_TEXT_PREVIEW_LENGTH) + '…';
      }
      return text;
    }

    function expandableToggleInnerHtml(rowId, isExpanded) {
      var labels = expandableRowLabels[rowId] || {closed: 'Toon tekst', open: 'Verberg tekst'};
      var iconClass = isExpanded ? 'fa-minus-square' : 'fa-plus-square';
      return '<i class="far ' + iconClass + '"></i> ' + (isExpanded ? labels.open : labels.closed);
    }

    function renderExpandableTextCell(rowId, slotIndex, listing) {
      var text = getComparableValue(rowId, listing);
      if (!text) {
        return '<span class="text-muted">—</span>';
      }

      var key = rowId + '-' + slotIndex;
      var isExpanded = !!compareState.expandedDescriptions[key];
      var visibleText = isExpanded ? text : previewExpandableText(text);

      return '' +
        '<button type="button" class="btn btn-link btn-xs favorites-expandable-toggle" data-expand-key="' + key + '">' +
        expandableToggleInnerHtml(rowId, isExpanded) +
        '</button>' +
        '<div class="favorites-description-body">' + escapeHtml(visibleText) + '</div>';
    }

    function renderPriceCell(listing) {
      var lines = getPriceLines(listing);
      if (!lines.length) {
        return '<span class="text-muted">—</span>';
      }
      return lines.map(function (line) {
        return '<div class="favorites-compare-price-line">' + escapeHtml(line) + '</div>';
      }).join('');
    }

    function renderFacilitiesCell(listing) {
      var facilities = getFacilityNames(listing);
      if (!facilities.length) {
        return '<span class="text-muted">—</span>';
      }

      var fullList = facilities.join(', ');
      var visible = facilities.slice(0, MAX_FACILITY_PILLS);
      var remaining = facilities.length - visible.length;
      var pills = visible.map(function (name) {
        return '<span class="favorites-facility-pill">' + escapeHtml(name) + '</span>';
      }).join('');

      if (remaining > 0) {
        pills +=
          '<span class="favorites-facility-pill favorites-facility-pill-more" tabindex="0" role="note"' +
          ' title="' + escapeHtml(fullList) + '" aria-label="' + escapeHtml(fullList) + '">+' + remaining + '</span>';
      }

      return '<div class="favorites-facility-pills" title="' + escapeHtml(fullList) + '">' + pills + '</div>';
    }

    function renderValueCell(rowId, slotIndex) {
      var slotId = compareState.slotIds[slotIndex];
      var listing = getListingById(slotId);
      if (!listing) {
        return '<span class="text-muted">—</span>';
      }

      if (rowId === 'price') {
        return renderPriceCell(listing);
      }
      if (rowId === 'facilities') {
        return renderFacilitiesCell(listing);
      }
      if (expandableRowLabels[rowId]) {
        return renderExpandableTextCell(rowId, slotIndex, listing);
      }

      var value = getComparableValue(rowId, listing);
      return value ? escapeHtml(value) : '<span class="text-muted">—</span>';
    }

    function hasRentPricing() {
      return compareState.slotIds.some(function (slotId) {
        var listing = getListingById(slotId);
        return !!listing && Object.keys(listing.price_variants || {}).length > 0;
      });
    }

    function renderPriceUnitSelect() {
      var options = priceUnitOptions.map(function (option) {
        var selected = option.key === compareState.priceUnit ? ' selected' : '';
        return '<option value="' + option.key + '"' + selected + '>' + escapeHtml(option.label) + '</option>';
      }).join('');

      return '' +
        '<select class="form-control input-sm favorites-compare-price-unit" id="favorites-compare-price-unit" aria-label="Prijseenheid voor huurpanden">' +
        options +
        '</select>';
    }

    function renderSpecRow(rowId, category, diffHiddenRowIds) {
      var rowDefinition = rowDefinitions.find(function (item) {
        return item.id === rowId;
      });
      if (!rowDefinition) {
        return '';
      }

      var diffHidden = !!diffHiddenRowIds[rowId];
      var isHidden = !!compareState.collapsedCategories[category] || diffHidden;
      var hiddenClass = isHidden ? ' hidden' : '';
      // Kept separate from the collapsed class so opening a heading cannot
      // reveal a row that "Alleen verschillen" still hides.
      var diffHiddenAttr = diffHidden ? ' data-diff-hidden="1"' : '';

      // One selector drives every rental column, so it lives in the row label.
      var labelControlHtml = (rowId === 'price' && hasRentPricing())
        ? renderPriceUnitSelect()
        : '';

      return '' +
        '<tr class="favorites-compare-spec-row' + hiddenClass + '" data-row-id="' + rowId + '" data-category="' + category + '"' + diffHiddenAttr + '>' +
        '<td class="favorites-compare-spec-label-cell">' +
        '<div class="favorites-compare-spec-label">' +
        '<span class="favorites-row-handle" aria-hidden="true" title="Sleep om te verplaatsen">' +
        '<span></span><span></span><span></span><span></span><span></span><span></span>' +
        '</span>' +
        '<span>' + escapeHtml(rowDefinition.label) + '</span>' +
        '</div>' +
        labelControlHtml +
        '</td>' +
        '<td>' + renderValueCell(rowId, 0) + '</td>' +
        '<td>' + renderValueCell(rowId, 1) + '</td>' +
        '<td>' + renderValueCell(rowId, 2) + '</td>' +
        '<td>' + renderValueCell(rowId, 3) + '</td>' +
        '</tr>';
    }

    function renderCompareTable() {
      var diffHiddenRowIds = getDiffHiddenRowIds();
      var headHtml = '<th></th>';
      for (var i = 0; i < MAX_COMPARE_SLOTS; i++) {
        headHtml += renderSlotHeader(i);
      }
      $('#favorites-compare-table-head-row').html(headHtml);

      var bodyHtml = '';
      Object.keys(compareState.rowOrder).forEach(function (category) {
        bodyHtml += renderCategoryRow(category, isCategoryHiddenByDiff(category, diffHiddenRowIds));
        compareState.rowOrder[category].forEach(function (rowId) {
          bodyHtml += renderSpecRow(rowId, category, diffHiddenRowIds);
        });
      });
      $('#favorites-compare-table-body').html(bodyHtml);
    }

    function getSelectedInquiryListings() {
      var selected = [];
      compareState.slotIds.forEach(function (slotId, slotIndex) {
        var listing = getListingById(slotId);
        if (!listing) {
          return;
        }
        if (!compareState.inquirySelections[slotIndex]) {
          return;
        }
        selected.push(listing);
      });
      return selected;
    }

    function getInquirySubmitIds() {
      if (Array.isArray(compareState.inquirySubmitIds) && compareState.inquirySubmitIds.length) {
        return compareState.inquirySubmitIds.slice();
      }
      return getSelectedInquiryListings().map(function (listing) {
        return listing.id;
      });
    }

    function getInquirySubmitListings() {
      return getInquirySubmitIds().map(function (listingId) {
        return getListingById(listingId);
      }).filter(function (listing) {
        return !!listing;
      });
    }

    function updateInquiryFooter() {
      var selectedCount = getSelectedInquiryListings().length;
      var label = selectedCount === 1 ? 'pand geselecteerd voor aanvraag' : 'panden geselecteerd voor aanvraag';
      $('#favorites-compare-selection-count').text(selectedCount);
      $('#favorites-compare-selection-label').text(label);
      $('#favorites-compare-start-inquiry').prop('disabled', selectedCount === 0);
    }

    function updateSharePreview() {
      $('#favorites-compare-url-preview').text(buildShareUrl());
    }

    function renderCompare() {
      renderCompareTable();
      var favoriteIds = getFavoriteCompareIds();
      var selectedIds = getSelectedSlotIds().map(toInt);
      var available = favoriteIds.filter(function (id) {
        return selectedIds.indexOf(id) === -1;
      });
      var summary = favoriteIds.length + ' favorieten opgeslagen · ' + selectedIds.length +
        ' van maximaal ' + MAX_COMPARE_SLOTS + ' in vergelijking.';
      if (available.length) {
        summary += ' Niet geselecteerd: ' + available.map(function (id) {
          return getListingLinkLabel(getListingById(id));
        }).join(', ') + '. Kies dit pand in een kolom om te vervangen.';
      }
      $('#favorites-compare-picker-status').text(summary);
      updateInquiryFooter();
      updateSharePreview();
    }

    function getRowId($row) {
      return String($row.attr('data-row-id') || '');
    }

    function getRowCategory($row) {
      return String($row.attr('data-category') || '');
    }

    function clearDragIndicators($tableBody) {
      $tableBody.find('.favorites-compare-spec-row').removeClass('drag-over-top drag-over-bottom is-dragging');
      $tableBody.find('.favorites-compare-category-row').removeClass('drag-over-category');
    }

    function moveRowWithinCategory(category, rowId, targetRowId, dropBefore) {
      if (!category || !rowId || !targetRowId || rowId === targetRowId) {
        return;
      }
      var rows = compareState.rowOrder[category] || [];
      var sourceIndex = rows.indexOf(rowId);
      var targetIndex = rows.indexOf(targetRowId);
      if (sourceIndex === -1 || targetIndex === -1) {
        return;
      }
      rows.splice(sourceIndex, 1);
      var insertIndex = rows.indexOf(targetRowId);
      if (!dropBefore) {
        insertIndex += 1;
      }
      rows.splice(insertIndex, 0, rowId);
    }

    function moveRowToIndexInCategory(category, rowId, targetIndex) {
      if (!category || !rowId) {
        return;
      }
      var rows = compareState.rowOrder[category] || [];
      var sourceIndex = rows.indexOf(rowId);
      if (sourceIndex === -1) {
        return;
      }
      var normalizedTarget = Math.max(0, Math.min(targetIndex, rows.length - 1));
      if (sourceIndex === normalizedTarget) {
        return;
      }
      rows.splice(sourceIndex, 1);
      rows.splice(normalizedTarget, 0, rowId);
    }

    function findDropTarget(clientY, category, draggedRowId) {
      var $tableBody = $('#favorites-compare-table-body');
      var dropTarget = null;

      $tableBody.find('.favorites-compare-spec-row:visible').each(function () {
        var $row = $(this);
        var rowCategory = getRowCategory($row);
        var rowId = getRowId($row);
        if (rowCategory !== category || rowId === draggedRowId) {
          return;
        }

        var rect = this.getBoundingClientRect();
        if (clientY >= rect.top && clientY <= rect.bottom) {
          dropTarget = {
            type: 'row',
            category: category,
            targetRowId: rowId,
            dropBefore: clientY < rect.top + rect.height / 2,
          };
          return false;
        }
      });

      if (!dropTarget) {
        $tableBody.find('.favorites-compare-category-row:visible').each(function () {
          var $row = $(this);
          if (getRowCategory($row) !== category) {
            return;
          }

          var rect = this.getBoundingClientRect();
          if (clientY >= rect.top && clientY <= rect.bottom) {
            dropTarget = {
              type: 'category',
              category: category,
            };
            return false;
          }
        });
      }

      return dropTarget;
    }

    function updateDragIndicators(dropTarget) {
      var $tableBody = $('#favorites-compare-table-body');
      clearDragIndicators($tableBody);

      if (!dropTarget) {
        return;
      }

      if (dropTarget.type === 'row') {
        $tableBody.find('.favorites-compare-spec-row[data-row-id="' + dropTarget.targetRowId + '"]')
          .addClass(dropTarget.dropBefore ? 'drag-over-top' : 'drag-over-bottom');
      } else if (dropTarget.type === 'category') {
        $tableBody.find('.favorites-compare-category-row[data-category="' + dropTarget.category + '"]')
          .addClass('drag-over-category');
      }
    }

    function stopPointerDrag() {
      $(document).off('.comparePointerDrag');

      if (compareState.pointerDrag && compareState.pointerDrag.$row) {
        compareState.pointerDrag.$row.removeClass('is-dragging');
      }

      compareState.pointerDrag = null;
      $('body').removeClass('favorites-compare-row-dragging');
      clearDragIndicators($('#favorites-compare-table-body'));
    }

    function finishPointerDrag(clientY) {
      var drag = compareState.pointerDrag;
      if (!drag) {
        return false;
      }

      var dropTarget = drag.dropTarget || findDropTarget(clientY, drag.category, drag.rowId);
      var reordered = false;

      if (dropTarget && dropTarget.type === 'row' && dropTarget.targetRowId) {
        moveRowWithinCategory(drag.category, drag.rowId, dropTarget.targetRowId, dropTarget.dropBefore);
        reordered = true;
      } else if (dropTarget && dropTarget.type === 'category') {
        moveRowToIndexInCategory(drag.category, drag.rowId, 0);
        reordered = true;
      }

      stopPointerDrag();
      return reordered;
    }

    function startPointerDrag($row, clientY) {
      var rowId = getRowId($row);
      var category = getRowCategory($row);
      if (!rowId || !category) {
        return;
      }

      stopPointerDrag();

      compareState.pointerDrag = {
        rowId: rowId,
        category: category,
        $row: $row,
        dropTarget: null,
      };
      $row.addClass('is-dragging');
      $('body').addClass('favorites-compare-row-dragging');
      updateDragIndicators(findDropTarget(clientY, category, rowId));

      $(document).on('mousemove.comparePointerDrag touchmove.comparePointerDrag', function (moveEvent) {
        if (!compareState.pointerDrag) {
          return;
        }

        moveEvent.preventDefault();

        var point = moveEvent.type.indexOf('touch') === 0
          ? moveEvent.originalEvent.touches[0]
          : moveEvent;
        if (!point) {
          return;
        }

        var nextTarget = findDropTarget(point.clientY, compareState.pointerDrag.category, compareState.pointerDrag.rowId);
        compareState.pointerDrag.dropTarget = nextTarget;
        updateDragIndicators(nextTarget);
      });

      $(document).on('mouseup.comparePointerDrag touchend.comparePointerDrag touchcancel.comparePointerDrag', function (upEvent) {
        if (!compareState.pointerDrag) {
          return;
        }

        upEvent.preventDefault();

        var point = upEvent.type.indexOf('touch') === 0
          ? (upEvent.originalEvent.changedTouches[0] || upEvent.originalEvent.touches[0])
          : upEvent;
        var clientY = point ? point.clientY : 0;
        var reordered = finishPointerDrag(clientY);

        if (reordered) {
          renderCompare();
          bindCompareEvents();
        }
      });
    }

    function bindDragAndDropEvents() {
      var $tableBody = $('#favorites-compare-table-body');

      stopPointerDrag();
      $tableBody.off('.compareDrag');

      $tableBody.on('mousedown.compareDrag touchstart.compareDrag', '.favorites-row-handle', function (event) {
        if (event.type === 'mousedown' && event.button !== 0) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        var $row = $(this).closest('.favorites-compare-spec-row');
        var point = event.type.indexOf('touch') === 0
          ? event.originalEvent.touches[0]
          : event;
        if (!point) {
          return;
        }

        startPointerDrag($row, point.clientY);
      });
    }

    function compareTableWrap() {
      return document.querySelector('.favorites-compare-table-wrap');
    }

    // Rebuilding the table removes the focused control. Chrome then scrolls the
    // overflow container back to the top. These toggles update the existing
    // rows instead, and this lock corrects any scroll-anchoring adjustment.
    function preserveCompareScroll(mutate) {
      var wrap = compareTableWrap();
      var scrollTop = wrap ? wrap.scrollTop : 0;
      var scrollLeft = wrap ? wrap.scrollLeft : 0;
      mutate();
      if (!wrap) {
        return;
      }
      if (wrap.scrollTop !== scrollTop) {
        wrap.scrollTop = scrollTop;
      }
      if (wrap.scrollLeft !== scrollLeft) {
        wrap.scrollLeft = scrollLeft;
      }
      compareScrollRestore = {
        wrap: wrap,
        top: scrollTop,
        left: scrollLeft,
        generation: compareScrollGeneration,
      };
      if (compareScrollRestoreFrame) {
        return;
      }
      compareScrollRestoreFrame = window.requestAnimationFrame(function () {
        compareScrollRestoreFrame = 0;
        var saved = compareScrollRestore;
        compareScrollRestore = null;
        if (!saved || saved.generation !== compareScrollGeneration || !saved.wrap.isConnected) {
          return;
        }
        if (saved.wrap.scrollTop !== saved.top) {
          saved.wrap.scrollTop = saved.top;
        }
        if (saved.wrap.scrollLeft !== saved.left) {
          saved.wrap.scrollLeft = saved.left;
        }
      });
    }

    function toggleCompareCategory(category) {
      var collapsed = !compareState.collapsedCategories[category];
      compareState.collapsedCategories[category] = collapsed;
      var iconClass = collapsed ? 'fa-chevron-right' : 'fa-chevron-down';

      $('#favorites-compare-table-body .favorites-category-toggle').each(function () {
        if (this.getAttribute('data-category') !== category) {
          return;
        }
        $(this).find('i').attr('class', 'fas ' + iconClass);
      });

      $('#favorites-compare-table-body .favorites-compare-spec-row').each(function () {
        if (this.getAttribute('data-category') !== category) {
          return;
        }
        var keepHidden = collapsed || this.getAttribute('data-diff-hidden') === '1';
        $(this).toggleClass('hidden', keepHidden);
      });
    }

    function toggleExpandableText(key) {
      var separator = key.lastIndexOf('-');
      if (separator <= 0) {
        return;
      }
      var rowId = key.slice(0, separator);
      var slotIndex = toInt(key.slice(separator + 1));
      if (!expandableRowLabels[rowId] || slotIndex === null) {
        return;
      }

      var expanded = !compareState.expandedDescriptions[key];
      var listing = getListingById(compareState.slotIds[slotIndex]);
      var text = listing ? String(getComparableValue(rowId, listing) || '') : '';
      var $button = $('#favorites-compare-table-body .favorites-expandable-toggle').filter(function () {
        return this.getAttribute('data-expand-key') === key;
      });
      if (!$button.length || !text) {
        return;
      }

      compareState.expandedDescriptions[key] = expanded;
      $button.html(expandableToggleInnerHtml(rowId, expanded));
      $button.next('.favorites-description-body').text(expanded ? text : previewExpandableText(text));
    }

    function bindCompareEvents() {
      $('.favorites-slot-select').off('change').on('change', function () {
        var slotIndex = toInt($(this).data('slot-index'));
        var selectedId = toInt($(this).val());
        if (slotIndex === null) {
          return;
        }

        if (selectedId && getFavoriteCompareIds().indexOf(selectedId) === -1) {
          selectedId = null;
        }

        if (selectedId) {
          compareState.slotIds.forEach(function (slotId, index) {
            if (index !== slotIndex && Number(slotId) === Number(selectedId)) {
              compareState.slotIds[index] = '';
              compareState.inquirySelections[index] = false;
            }
          });
        }

        compareState.slotIds[slotIndex] = selectedId || '';
        compareState.inquirySelections[slotIndex] = !!selectedId;
        renderCompare();
        bindCompareEvents();
      });

      $('.favorites-slot-remove').off('click').on('click', function () {
        var slotIndex = toInt($(this).data('slot-index'));
        if (slotIndex === null) {
          return;
        }
        compareState.slotIds[slotIndex] = '';
        compareState.inquirySelections[slotIndex] = false;
        renderCompare();
        bindCompareEvents();
      });

      $('.favorites-slot-inquiry-checkbox').off('change').on('change', function () {
        var slotIndex = toInt($(this).data('slot-index'));
        if (slotIndex === null) {
          return;
        }
        compareState.inquirySelections[slotIndex] = $(this).is(':checked');
        updateInquiryFooter();
      });

      $('#favorites-compare-price-unit').off('change').on('change', function () {
        var unit = $(this).val();
        if (!isKnownPriceUnit(unit)) {
          return;
        }
        compareState.priceUnit = unit;
        storePriceUnit(unit);
        renderCompare();
        bindCompareEvents();
        // The table is rebuilt on every render, so hand focus back to the
        // freshly created selector for keyboard users.
        $('#favorites-compare-price-unit').trigger('focus');
      });

      $('.favorites-category-toggle').off('click').on('click', function () {
        var category = this.getAttribute('data-category');
        if (!category || !Object.prototype.hasOwnProperty.call(compareState.rowOrder, category)) {
          return;
        }
        preserveCompareScroll(function () {
          toggleCompareCategory(category);
        });
      });

      $('.favorites-expandable-toggle').off('click').on('click', function () {
        var key = this.getAttribute('data-expand-key') || '';
        if (!key) {
          return;
        }
        preserveCompareScroll(function () {
          toggleExpandableText(key);
        });
      });

      bindDragAndDropEvents();
    }

    function populateInquirySelectedList() {
      var html = '';
      var selectedListings = getInquirySubmitListings();
      selectedListings.forEach(function (listing) {
        var address = listing.address || listing.street_name || ('Pand ' + listing.id);
        var providerName = listing.provider_name || '';
        html += '<div class="favorites-inquiry-selected-item">' +
          '<span class="favorites-inquiry-address">' + escapeHtml(address) + '</span>';
        if (providerName) {
          html += '<span class="favorites-inquiry-provider">' + escapeHtml(providerName) + '</span>';
        }
        html += '</div>';
      });
      $('#favorites-compare-selected-list').html(html || '<div class="favorites-inquiry-selected-item">Geen panden geselecteerd.</div>');
    }

    function goToInquiryStep() {
      var selectedListings = getSelectedInquiryListings();
      if (!selectedListings.length) {
        return;
      }
      compareState.inquirySubmitIds = selectedListings.map(function (listing) {
        return listing.id;
      });
      fillInquiryFormFromPrefill();
      populateInquirySelectedList();
      showInquiryStep();
      setCompareTitle('Informatie aanvragen', selectedListings.length + ' pand' + (selectedListings.length === 1 ? '' : 'en') + ' geselecteerd');
    }

    function backToCompareStep() {
      compareState.inquirySubmitIds = null;
      showCompareStep();
      setCompareTitle('Panden vergelijken', 'Kies tot 4 panden uit je favorieten');
    }

    function submitCompareInquiry(event) {
      event.preventDefault();

      var selectedIds = canonicalizeIds(getInquirySubmitIds(), MAX_COMPARE_SLOTS);

      if (!selectedIds.length) {
        $('#favorites-compare-inquiry-status').text('Selecteer minimaal één pand.');
        return;
      }

      var payload = {
        'selected_ids': selectedIds,
        'name': $('#compare-inquiry-name').val(),
        'surname': $('#compare-inquiry-surname').val(),
        'email': $('#compare-inquiry-email').val(),
        'phone': $('#compare-inquiry-phone').val(),
        'company_name': $('#compare-inquiry-company').val(),
        'message': $('#compare-inquiry-message').val(),
        'air': $('#compare-inquiry-air').val() || '',
      };

      $('#favorites-compare-submit-inquiry').prop('disabled', true);
      $('#favorites-compare-inquiry-status').text('Aanvraag wordt verstuurd…');

      $.ajax({
        url: '/data/pandvergelijker/inquiry/',
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        headers: {
          'X-CSRFToken': getCsrfToken(),
          'X-Requested-With': 'XMLHttpRequest',
        },
        data: JSON.stringify(payload),
        success: function (result) {
          var count = result.inquiry_count || selectedIds.length;
          var statusMessage = 'Uw aanvraag is verzonden voor ' + count + ' pand' + (count === 1 ? '' : 'en') + '.';
          if (result.skipped_ids && result.skipped_ids.length) {
            statusMessage += ' ' + result.skipped_ids.length + ' pand' + (result.skipped_ids.length === 1 ? '' : 'en') + ' kon niet worden meegenomen.';
          }
          $('#favorites-compare-inquiry-status').text(statusMessage);
          $('#favorites-compare-submit-inquiry').prop('disabled', false);
          backToCompareStep();
        },
        error: function (xhr) {
          var message = 'Er is iets misgegaan. Probeer het opnieuw.';
          if (xhr.responseJSON && xhr.responseJSON.errors) {
            var firstKey = Object.keys(xhr.responseJSON.errors)[0];
            var firstValue = xhr.responseJSON.errors[firstKey];
            if (Array.isArray(firstValue) && firstValue.length) {
              message = firstValue[0];
            }
          }
          $('#favorites-compare-inquiry-status').text(message);
          $('#favorites-compare-submit-inquiry').prop('disabled', false);
        },
      });
    }

    function copyCompareUrl() {
      var shareUrl = buildShareUrl();
      var $button = $('#favorites-compare-copy-link');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareUrl).then(function () {
          $button.html('<i class="fas fa-check"></i> Gekopieerd');
          setTimeout(function () {
            $button.html('<i class="fas fa-link"></i> Link kopiëren');
          }, 1700);
        });
      }
    }

    function shareCompareByEmail() {
      var shareUrl = buildShareUrl();
      var subjectParts = ['Bedrijfspand.com Pandenvergelijker'];
      var streetNames = getShareStreetNames();
      if (streetNames.length) {
        subjectParts.push(streetNames.join(', '));
      }
      var subject = subjectParts.join(' ');
      var mailto = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(shareUrl);
      window.location.href = mailto;
    }

    function openCompare(ids) {
      var $modal = $('#favorites-compare-modal');
      if (!$modal.length) {
        var fallbackUrl = '/pandvergelijker/';
        var parsedIds = parseUrlIds(ids);
        if (parsedIds.length) {
          fallbackUrl += '?ids=' + parsedIds.join(',');
        }
        window.location.href = fallbackUrl;
        return;
      }

      var requestedIds = parseUrlIds(ids);
      ensureCompareDataForIds(requestedIds.concat(favoritePks), function () {
        if (requestedIds.length) {
          setSlotsFromIds(requestedIds);
        } else if (!getSelectedSlotIds().length) {
          setSlotsFromIds(getDefaultSlotIds());
        }

        renderCompare();
        bindCompareEvents();
        setCompareTitle('Panden vergelijken', 'Kies tot 4 panden uit je favorieten');
        showCompareStep();
        $modal.modal('show');
      });
    }

    function initializeCompareModal() {
      if (compareState.initialized) {
        return;
      }
      compareState.priceUnit = readStoredPriceUnit();
      if (!$('#favorites-compare-modal').length) {
        return;
      }
      compareState.initialized = true;

      $('#favorites-compare-diff-only').on('change', function () {
        compareState.diffOnly = $(this).is(':checked');
        renderCompare();
        bindCompareEvents();
      });

      $('#favorites-compare-select-all').on('click', function () {
        compareState.slotIds.forEach(function (slotId, slotIndex) {
          compareState.inquirySelections[slotIndex] = !!toInt(slotId);
        });
        updateInquiryFooter();
        renderCompare();
        bindCompareEvents();
      });

      $('#favorites-compare-select-none').on('click', function () {
        compareState.inquirySelections = [false, false, false, false];
        updateInquiryFooter();
        renderCompare();
        bindCompareEvents();
      });

      $('#favorites-compare-start-inquiry').on('click', goToInquiryStep);
      $('#favorites-compare-back-to-compare').on('click', backToCompareStep);
      $('#favorites-compare-inquiry-form').on('submit', submitCompareInquiry);
      $('#favorites-compare-copy-link').on('click', copyCompareUrl);
      $('#favorites-compare-share-email').on('click', shareCompareByEmail);

      $('#favorites-compare-modal').on('hidden.bs.modal', function () {
        resetCompareSessionState();
      });
    }

    function updateFavoriteButtons(result) {
      var favoritePks = result.favorite_pks || [];
      $('.favorite-button').each(function () {
        var $button = $(this);
        var isActive = favoritePks.indexOf($button.data('pk')) !== -1;
        var icon = $button.find('i');
        if (isActive) {
          $button.addClass('active');
          if (icon.hasClass('far fa-heart')) {
            icon.removeClass('far fa-heart').addClass('fas fa-heart');
          }
        } else {
          $button.removeClass('active');
          if (icon.hasClass('fas fa-heart')) {
            icon.removeClass('fas fa-heart').addClass('far fa-heart');
          }
        }
      });
    }

    var _get_favorites = function (shake) {
      $.ajax({
        dataType: 'json',
        url: '/data/favorites/',
        cache: false,
        async: true,
        success: function (result) {
          _store_favorite_state(result);
          userIsAuthenticated = result.authenticated === true;
          updateFavoriteButtons(result);
          $('#favorite-dropdown').replaceWith(result.html);
          initializeCompareModal();
          if (isCompareUiVisible()) {
            refreshOpenCompare();
          }

          if (shake) {
            var $toggle = $('#favorite-dropdown .favorites-toggle-link');
            if ($toggle.length) {
              bp.effects.shake($toggle);
            }
          }

          if (window.bpCompareInitialIds && !compareState.comparePageBootstrapped) {
            compareState.comparePageBootstrapped = true;
            openCompare(window.bpCompareInitialIds);
          }
        },
      });
    };

    var _toggle_show_on_map = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      $.ajax({
        dataType: 'json',
        type: 'POST',
        data: {'action_type': 'toggle_show_on_map'},
        url: '/data/favorites/update/',
        cache: false,
        async: true,
        success: function (result) {
          _store_favorite_state(result);
          bp.favorites.get_favorites(false);
        },
      });
    };

    var _toggle_favorite = function (clicked_button) {
      var pk = clicked_button.data('pk');
      var action_type = (clicked_button.hasClass('active') ? 'delete' : 'add');

      if (
        action_type === 'add' &&
        !userIsAuthenticated &&
        favoritePks.length >= GUEST_FAVORITE_LIMIT
      ) {
        window.location.href = getLoginRedirectUrl();
        return;
      }

      bp.favorites.toggle_icon_class(clicked_button.find('i'));

      $.ajax({
        dataType: 'json',
        type: 'POST',
        data: {
          'action_type': action_type,
          'pk': pk,
        },
        url: '/data/favorites/update/',
        cache: false,
        async: true,
        success: function () {
          if (typeof ga === 'function') {
            ga('send', {
              'hitType': 'event',
              'eventCategory': 'estate_offer',
              'eventAction': 'favorite_' + action_type,
              'eventLabel': pk,
            });
          }
          bp.favorites.get_favorites(true);
        },
      });
    };

    var _delete_all = function () {
      if (confirm('Weet je zeker dat je al je favorieten wilt wissen?')) {
        $.ajax({
          dataType: 'json',
          type: 'POST',
          data: {'action_type': 'delete_all'},
          url: '/data/favorites/update/',
          cache: false,
          async: true,
          success: function () {
            bp.favorites.get_favorites(true);
          },
        });
      }
    };

    function initFavoritesPage() {
      var $page = $('#favorites-page');
      if (!$page.length) {
        return;
      }

      var noteTimers = {};
      var noteRequests = {};
      var lastPayload = {};

      function ratingValue($card) {
        var rating = parseInt($card.find('.favorites-stars').attr('data-rating'), 10);
        if (rating >= 1 && rating <= 5) {
          return rating;
        }
        return 0;
      }

      function payloadKey($card) {
        return ($card.find('.favorites-note').val() || '') + '\n' + ratingValue($card);
      }

      function paintStars($card, rating) {
        var $stars = $card.find('.favorites-stars');
        $stars.attr('data-rating', rating ? String(rating) : '');
        $stars.find('.favorites-star').each(function () {
          var value = parseInt($(this).attr('data-value'), 10);
          $(this).toggleClass('on', !!rating && value <= rating);
        });
        $stars.find('.favorites-score').text(rating ? rating + '/5' : 'Nog geen score');
      }

      function sendAnnotation($card) {
        var pk = String($card.data('pk'));
        var key = payloadKey($card);
        if (lastPayload[pk] === key) {
          return;
        }
        if (noteRequests[pk]) {
          noteRequests[pk].abort();
        }
        var rating = ratingValue($card);
        noteRequests[pk] = $.ajax({
          url: '/data/favorites/annotate/',
          method: 'POST',
          dataType: 'json',
          headers: {
            'X-CSRFToken': getCsrfToken(),
          },
          data: {
            pk: pk,
            note: $card.find('.favorites-note').val() || '',
            rating: rating ? String(rating) : '',
            csrfmiddlewaretoken: getCsrfToken(),
          },
          success: function () {
            lastPayload[pk] = key;
          },
          error: function (xhr) {
            if (xhr && xhr.statusText === 'abort') {
              return;
            }
            delete lastPayload[pk];
          },
          complete: function (xhr) {
            if (noteRequests[pk] === xhr) {
              delete noteRequests[pk];
            }
          },
        });
      }

      function scheduleAnnotation($card, immediate) {
        var pk = String($card.data('pk'));
        window.clearTimeout(noteTimers[pk]);
        if (immediate) {
          sendAnnotation($card);
          return;
        }
        noteTimers[pk] = window.setTimeout(function () {
          sendAnnotation($card);
        }, 400);
      }

      $page.find('.favorites-card').each(function () {
        var $card = $(this);
        lastPayload[String($card.data('pk'))] = payloadKey($card);
      });

      $page.on('click', '.favorites-star', function (event) {
        event.preventDefault();
        var $card = $(this).closest('.favorites-card');
        var value = parseInt($(this).attr('data-value'), 10);
        var current = ratingValue($card);
        paintStars($card, current === value ? 0 : value);
        scheduleAnnotation($card, true);
      });

      $page.on('input', '.favorites-note', function () {
        scheduleAnnotation($(this).closest('.favorites-card'), false);
      });

      $page.on('change', '.favorites-note', function () {
        scheduleAnnotation($(this).closest('.favorites-card'), true);
      });

      // Flush debounced edits when the page is left, so a note typed just before
      // navigating away is not lost.
      function flushPendingAnnotations() {
        $page.find('.favorites-card').each(function () {
          var $card = $(this);
          var pk = String($card.data('pk'));
          if (noteTimers[pk] === undefined) {
            return;
          }
          window.clearTimeout(noteTimers[pk]);
          delete noteTimers[pk];
          if (lastPayload[pk] === payloadKey($card) || !navigator.sendBeacon) {
            return;
          }
          var body = new FormData();
          body.append('pk', pk);
          body.append('note', $card.find('.favorites-note').val() || '');
          body.append('rating', ratingValue($card) ? String(ratingValue($card)) : '');
          body.append('csrfmiddlewaretoken', getCsrfToken());
          navigator.sendBeacon('/data/favorites/annotate/', body);
        });
      }

      $(window).on('pagehide', flushPendingAnnotations);

      $page.on('click', '.favorites-note-add', function () {
        var $button = $(this);
        $button.attr('hidden', 'hidden').attr('aria-expanded', 'true');
        $button.siblings('.favorites-note').removeAttr('hidden').trigger('focus');
      });

      $page.on('click', '.favorites-remove-open', function () {
        var $card = $(this).closest('.favorites-card');
        $page.find('.favorites-remove-confirm').attr('hidden', 'hidden');
        $card.find('.favorites-remove-confirm').removeAttr('hidden').find('.favorites-remove-no').trigger('focus');
      });

      $page.on('click', '.favorites-remove-no', function () {
        var $confirm = $(this).closest('.favorites-remove-confirm');
        $confirm.attr('hidden', 'hidden');
        $confirm.closest('.favorites-remove').find('.favorites-remove-open').trigger('focus');
      });

      $page.on('keydown', '.favorites-remove-confirm', function (event) {
        if (event.key === 'Escape') {
          $(this).find('.favorites-remove-no').trigger('click');
        }
      });

      function refreshCount() {
        var count = $page.find('.favorites-card').length;
        $page.find('.favorites-count').text(count === 1 ? '1 pand' : count + ' panden');
        $page.find('.favorites-list').toggleClass('is-empty', !count).prop('hidden', !count);
        $page.find('.favorites-empty').prop('hidden', !!count);
      }

      // The card disappears right away; it is put back if the server refuses.
      $page.on('click', '.favorites-remove-yes', function (event) {
        event.preventDefault();
        var $card = $(this).closest('.favorites-card');
        var pk = String($card.data('pk'));
        var $placeholder = $('<span hidden></span>').insertAfter($card);
        if (noteRequests[pk]) {
          noteRequests[pk].abort();
        }
        window.clearTimeout(noteTimers[pk]);
        delete noteTimers[pk];
        $card.detach();
        refreshCount();
        $.ajax({
          url: '/data/favorites/update/',
          method: 'POST',
          dataType: 'json',
          headers: {
            'X-CSRFToken': getCsrfToken(),
          },
          data: {
            action_type: 'delete',
            pk: pk,
            csrfmiddlewaretoken: getCsrfToken(),
          },
          success: function () {
            bp.favorites.get_favorites(false);
          },
          error: function () {
            $card.find('.favorites-remove-confirm').attr('hidden', 'hidden');
            $placeholder.before($card);
            refreshCount();
          },
          complete: function () {
            $placeholder.remove();
          },
        });
      });
    }

    $(document).ready(function () {
      $(document).on('click', '.favorite-button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var clicked_button = $(this);
        bp.favorites.toggle_favorite(clicked_button);
      });

      $(document).on('click', '.favorites-compare-open', function (e) {
        var idsAttr = $(this).attr('data-ids');
        if ($(this).hasClass('is-disabled')) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        openCompare(parseUrlIds(idsAttr));
      });

      $(window).on('focus', function () {
        if (isCompareUiVisible()) {
          _get_favorites(false);
        }
      });

      initializeCompareModal();
      initFavoritesPage();
      _get_favorites(false);
    });

    return {
      get_favorites: function (shake) {
        _get_favorites(shake);
      },
      open_compare: function (ids) {
        openCompare(ids || []);
      },
      toggle_favorite: function (pk) {
        _toggle_favorite(pk);
      },
      delete_all: function () {
        _delete_all();
      },
      show_favorites_on_map_enabled: function () {
        return showFavoritesOnMap;
      },
      toggle_show_on_map: function (event) {
        _toggle_show_on_map(event);
      },
      toggle_icon_class: function (icon) {
        icon.hasClass('far')
          ? icon.removeClass('far fa-heart').addClass('fas fa-heart')
          : icon.removeClass('fas fa-heart').addClass('far fa-heart');
      },
    };
  })(),
});

export {bp};
